(() => {
  const HV = (window.HV = window.HV || {});
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const S = window.hvStrings || {};
  const CFG = window.hvSettings || {};

  HV.routes = {
    add: root + 'cart/add.js',
    change: root + 'cart/change.js',
    cart: root + 'cart.js',
  };

  HV.emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { detail }));

  HV.reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  HV.toast = (message) => {
    let el = document.getElementById('HvToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'HvToast';
      el.className = 'hv-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.hidden = true;
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      el.hidden = true;
    }, 2800);
  };

  HV.cartSectionIds = () =>
    Array.from(document.querySelectorAll('[data-hv-cart-section]')).map((el) => el.dataset.hvCartSection);

  HV.renderSections = (sections) => {
    if (!sections) return;
    Object.keys(sections).forEach((id) => {
      const html = sections[id];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll(`[data-hv-cart-section="${id}"]`).forEach((target) => {
        const fresh = doc.querySelector(`[data-hv-cart-section="${id}"]`);
        if (fresh) {
          target.innerHTML = fresh.innerHTML;
          HV.hydrate(target);
        }
      });
    });
  };

  HV.updateCount = (count) => {
    document.querySelectorAll('[data-hv-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-hv-cart-open][data-label-template]').forEach((el) => {
      el.setAttribute('aria-label', el.dataset.labelTemplate.replace('[count]', count));
    });
  };

  const postJSON = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      const err = new Error(data.description || data.message || S.cartError || 'Something went wrong.');
      err.data = data;
      throw err;
    }
    return data;
  };

  HV.cart = {
    async get() {
      const res = await fetch(HV.routes.cart, { headers: { Accept: 'application/json' } });
      return res.json();
    },
    async add(items) {
      const ids = HV.cartSectionIds();
      const body = { items };
      if (ids.length) {
        body.sections = ids.join(',');
        body.sections_url = window.location.pathname;
      }
      const data = await postJSON(HV.routes.add, body);
      HV.renderSections(data.sections);
      const cart = await HV.cart.get();
      HV.updateCount(cart.item_count);
      HV.emit('hv:cart:updated', { cart, added: data.items || [] });
      return { data, cart };
    },
    async change(key, quantity) {
      const ids = HV.cartSectionIds();
      const body = { id: key, quantity };
      if (ids.length) {
        body.sections = ids.join(',');
        body.sections_url = window.location.pathname;
      }
      const data = await postJSON(HV.routes.change, body);
      HV.renderSections(data.sections);
      HV.updateCount(data.item_count);
      HV.emit('hv:cart:updated', { cart: data });
      return data;
    },
  };

  HV.refreshCart = async () => {
    const ids = HV.cartSectionIds();
    const url = HV.routes.cart + (ids.length ? `?sections=${ids.join(',')}` : '');
    const data = await fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (data.sections) HV.renderSections(data.sections);
    HV.updateCount(data.item_count);
    HV.emit('hv:cart:updated', { cart: data });
    return data;
  };

  HV.openCart = (trigger) => {
    const drawer = document.querySelector('hv-cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return true;
    }
    return false;
  };

  HV.afterAdd = (trigger) => {
    if (!HV.openCart(trigger)) HV.toast(S.added || 'Added to cart');
  };

  const flashAdded = (btn) => {
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    clearTimeout(btn._hvT);
    btn._hvT = setTimeout(() => btn.classList.remove('is-added'), 1600);
  };

  HV.addVariant = async (variantId, quantity, btn) => {
    if (btn) btn.classList.add('is-loading');
    try {
      await HV.cart.add([{ id: Number(variantId), quantity: quantity || 1 }]);
      flashAdded(btn);
      HV.afterAdd(btn);
    } catch (e) {
      if (btn) btn.classList.remove('is-loading');
      HV.toast(e.message);
    }
  };

  const formatMoney = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };
  HV.formatMoney = formatMoney;

  HV.choose = async (handle, trigger) => {
    let product;
    try {
      const res = await fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } });
      product = await res.json();
    } catch (e) {
      window.location.href = `${root}products/${handle}`;
      return;
    }
    let dlg = document.getElementById('HvChooser');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'HvChooser';
      dlg.className = 'hv-chooser';
      dlg.setAttribute('aria-labelledby', 'HvChooserTitle');
      document.body.appendChild(dlg);
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg) dlg.close();
      });
      dlg.addEventListener('close', () => {
        if (dlg._trigger && dlg._trigger.focus) dlg._trigger.focus();
      });
    }
    dlg._trigger = trigger;
    const firstAvail = product.variants.find((v) => v.available) || product.variants[0];
    const pills = product.variants
      .map(
        (v) =>
          `<button type="button" class="hv-pill" data-variant="${v.id}" data-price="${v.price}" aria-pressed="${v.id === firstAvail.id}" ${v.available ? '' : 'disabled'}>${v.title}${v.available ? '' : ' · ' + (S.soldOut || 'Sold out')}</button>`
      )
      .join('');
    dlg.innerHTML = `
      <div class="hv-chooser__inner">
        <div class="hv-chooser__head">
          <h2 class="hv-chooser__title" id="HvChooserTitle">${product.title}</h2>
          <button type="button" class="hv-icon-btn hv-icon-btn--outline" data-close aria-label="${S.close || 'Close'}">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></svg>
          </button>
        </div>
        <p class="hv-chooser__price" data-price-out>${formatMoney(firstAvail.price)}</p>
        <fieldset class="hv-chooser__set"><legend class="hv-sr">${S.chooseOption || 'Choose an option'}</legend><div class="hv-chooser__pills">${pills}</div></fieldset>
        <button type="button" class="hv-btn hv-btn--solid hv-btn--block" data-add>${S.addToCart || 'Add to cart'}</button>
        <a class="hv-link hv-chooser__more" href="${product.url}">${S.viewDetails || 'View details'}</a>
      </div>`;
    let selected = firstAvail.id;
    dlg.querySelectorAll('.hv-pill').forEach((p) =>
      p.addEventListener('click', () => {
        dlg.querySelectorAll('.hv-pill').forEach((x) => x.setAttribute('aria-pressed', 'false'));
        p.setAttribute('aria-pressed', 'true');
        selected = p.dataset.variant;
        dlg.querySelector('[data-price-out]').textContent = formatMoney(Number(p.dataset.price));
      })
    );
    dlg.querySelector('[data-close]').addEventListener('click', () => dlg.close());
    dlg.querySelector('[data-add]').addEventListener('click', async (e) => {
      const b = e.currentTarget;
      b.setAttribute('aria-disabled', 'true');
      try {
        await HV.cart.add([{ id: Number(selected), quantity: 1 }]);
        dlg.close();
        flashAdded(trigger);
        HV.afterAdd(trigger);
      } catch (err) {
        HV.toast(err.message);
      }
      b.removeAttribute('aria-disabled');
    });
    dlg.showModal();
  };

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-hv-add]');
    if (add) {
      e.preventDefault();
      HV.addVariant(add.dataset.hvAdd, Number(add.dataset.quantity || 1), add);
      return;
    }
    const choose = e.target.closest('[data-hv-choose]');
    if (choose) {
      e.preventDefault();
      HV.choose(choose.dataset.hvChoose, choose);
      return;
    }
    const cartOpen = e.target.closest('[data-hv-cart-open]');
    if (cartOpen && HV.openCart(cartOpen)) {
      e.preventDefault();
    }
  });

  const addBusinessDays = (date, n) => {
    const d = new Date(date.getTime());
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const w = d.getDay();
      if (w !== 0 && w !== 6) left--;
    }
    return d;
  };

  HV.eta = (scope) => {
    const els = (scope || document).querySelectorAll('[data-hv-eta]');
    if (!els.length) return;
    const lang = navigator.language || document.documentElement.lang || 'en-US';
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' });
    } catch (e) {
      fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    }
    const now = new Date();
    els.forEach((el) => {
      const min = Number(el.dataset.min || CFG.etaMin || 7);
      const max = Number(el.dataset.max || CFG.etaMax || 12);
      const a = fmt.format(addBusinessDays(now, min));
      const b = fmt.format(addBusinessDays(now, max));
      el.textContent = `${a} ${S.to || 'to'} ${b}`;
    });
  };

  const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
  HV.isEmail = isEmail;

  HV.subscribe = async (form, extra = {}) => {
    const emailInput = form.querySelector('input[type="email"]');
    const email = (extra.email || (emailInput && emailInput.value) || '').trim();
    if (!isEmail(email)) return { ok: false, reason: 'invalid' };
    const sourceEl = form.querySelector('[data-hv-source]');
    const source = extra.source || (sourceEl && sourceEl.value) || 'website';
    const props = Object.assign({}, extra.properties || {});
    form.querySelectorAll('[data-hv-prop]').forEach((el) => {
      if (el.value) props[el.dataset.hvProp] = el.value;
    });
    props.signup_source = props.signup_source || source;
    const k = (extra.klaviyo && extra.klaviyo.key && extra.klaviyo.list && extra.klaviyo) || CFG.klaviyo || {};
    if (k.key && k.list) {
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(k.key)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: k.revision || '2026-07-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: source,
                profile: { data: { type: 'profile', attributes: { email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
              },
              relationships: { list: { data: { type: 'list', id: k.list } } },
            },
          }),
        });
        if (res.status === 202 || res.ok) return HV._subscribed(email, source, props);
        return { ok: false, reason: 'error' };
      } catch (e) {
        return { ok: false, reason: 'error' };
      }
    }
    try {
      const fd = new FormData(form);
      fd.set('contact[email]', email);
      const res = await fetch(form.action, { method: 'POST', body: fd, headers: { Accept: 'text/html' } });
      if (res.redirected && /challenge/.test(res.url)) {
        form.submit();
        return { ok: false, reason: 'challenge' };
      }
      if (!res.ok) return { ok: false, reason: 'error' };
      return HV._subscribed(email, source, props);
    } catch (e) {
      return { ok: false, reason: 'error' };
    }
  };

  HV._subscribed = (email, source, props) => {
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: source });
    } catch (e) {}
    HV.emit('hv:subscribed', { email, source, properties: props });
    return { ok: true };
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.hv-subscribe');
    if (!form || form.hasAttribute('data-hv-custom-ui') || form.closest('hv-welcome')) return;
    e.preventDefault();
    const msg = form.querySelector('[data-hv-subscribe-msg]');
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    const result = await HV.subscribe(form);
    if (btn) btn.removeAttribute('aria-disabled');
    if (result.ok) {
      const fields = form.querySelector('[data-hv-subscribe-fields]');
      if (fields) fields.hidden = true;
      if (msg) {
        msg.textContent = msg.dataset.success || S.subscribed || 'Thank you.';
        msg.focus && msg.setAttribute('tabindex', '-1');
      }
      if (input) input.removeAttribute('aria-invalid');
    } else if (result.reason === 'invalid') {
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      if (msg) msg.innerHTML = `<span class="hv-form-msg--error">${msg.dataset.invalid || S.invalidEmail}</span>`;
    } else if (result.reason !== 'challenge') {
      if (msg) msg.innerHTML = `<span class="hv-form-msg--error">${msg.dataset.error || S.formError}</span>`;
    }
  });

  class HvHeader extends HTMLElement {
    connectedCallback() {
      this.menuBtn = this.querySelector('[data-hv-menu-toggle]');
      this.menu = this.menuBtn && document.getElementById(this.menuBtn.getAttribute('aria-controls'));
      this.searchBtn = this.querySelector('[data-hv-search-toggle]');
      this.search = this.searchBtn && document.getElementById(this.searchBtn.getAttribute('aria-controls'));
      this.onKey = this.onKey.bind(this);
      this.onDoc = this.onDoc.bind(this);
      if (this.menuBtn) this.menuBtn.addEventListener('click', () => this.toggleMenu());
      if (this.searchBtn) this.searchBtn.addEventListener('click', () => this.toggleSearch());
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDoc);
      this.mq = window.matchMedia('(min-width: 900px)');
      this.onMq = () => {
        if (this.mq.matches) this.toggleMenu(false);
      };
      this.mq.addEventListener('change', this.onMq);
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDoc);
      if (this.mq) this.mq.removeEventListener('change', this.onMq);
    }
    toggleMenu(force) {
      if (!this.menu) return;
      const open = typeof force === 'boolean' ? force : this.menuBtn.getAttribute('aria-expanded') !== 'true';
      this.menuBtn.setAttribute('aria-expanded', String(open));
      this.menuBtn.setAttribute('aria-label', open ? this.menuBtn.dataset.labelClose : this.menuBtn.dataset.labelOpen);
      this.menu.hidden = !open;
      this.menu.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('hv-menu-open', open);
      if (open) {
        const first = this.menu.querySelector('.hv-sheet__primary a') || this.menu.querySelector('a');
        if (first) setTimeout(() => first.focus(), 30);
      }
    }
    toggleSearch(force) {
      if (!this.search) return;
      const open = typeof force === 'boolean' ? force : this.searchBtn.getAttribute('aria-expanded') !== 'true';
      this.searchBtn.setAttribute('aria-expanded', String(open));
      this.search.hidden = !open;
      if (open) {
        this.search.classList.add('hv-fade');
        const input = this.search.querySelector('input[type="search"]');
        if (input) setTimeout(() => input.focus(), 30);
      }
    }
    onKey(e) {
      if (e.key !== 'Escape') return;
      if (this.menuBtn && this.menuBtn.getAttribute('aria-expanded') === 'true') {
        this.toggleMenu(false);
        this.menuBtn.focus();
      }
      if (this.searchBtn && this.searchBtn.getAttribute('aria-expanded') === 'true') {
        this.toggleSearch(false);
        this.searchBtn.focus();
      }
    }
    onDoc(e) {
      if (this.contains(e.target)) return;
      if (this.menuBtn && this.menuBtn.getAttribute('aria-expanded') === 'true') this.toggleMenu(false);
      if (this.searchBtn && this.searchBtn.getAttribute('aria-expanded') === 'true') this.toggleSearch(false);
    }
  }
  if (!customElements.get('hv-header')) customElements.define('hv-header', HvHeader);

  HV.focusables = (root) =>
    Array.from(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((el) => el.offsetParent !== null || el === document.activeElement);

  HV.lock = (on) => document.documentElement.classList.toggle('hv-lock', on);

  class HvCartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.hv-drawer__panel');
      this.onKey = this.onKey.bind(this);
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-hv-close]')) {
          e.preventDefault();
          this.close();
          return;
        }
        const q = e.target.closest('[data-hv-line-qty]');
        if (q) {
          const line = q.closest('[data-key]');
          if (line) this.changeLine(line.dataset.key, Number(q.dataset.hvLineQty));
        }
      });
    }
    async changeLine(key, qty) {
      this.classList.add('hv-is-busy');
      try {
        await HV.cart.change(key, Math.max(0, qty));
      } catch (e) {
        HV.toast(e.message);
      }
      this.classList.remove('hv-is-busy');
      const first = this.panel.querySelector('[data-hv-line-qty], [data-hv-close]');
      if (this.hasAttribute('open') && !this.contains(document.activeElement) && first) first.focus();
    }
    open(trigger) {
      if (this.hasAttribute('open')) return;
      this._trigger = trigger || document.activeElement;
      this.removeAttribute('inert');
      this.setAttribute('open', '');
      HV.lock(true);
      document.documentElement.classList.add('hv-cart-open');
      document.addEventListener('keydown', this.onKey);
      HV.eta(this);
      setTimeout(() => {
        const close = this.querySelector('[data-hv-close]:not(.hv-drawer__overlay)');
        (close || this.panel).focus();
      }, 60);
      HV.emit('hv:cart:open');
    }
    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      this.setAttribute('inert', '');
      HV.lock(false);
      document.documentElement.classList.remove('hv-cart-open');
      document.removeEventListener('keydown', this.onKey);
      if (this._trigger && this._trigger.focus && document.contains(this._trigger)) this._trigger.focus();
      HV.emit('hv:cart:close');
    }
    onKey(e) {
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;
      const items = HV.focusables(this.panel);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
  if (!customElements.get('hv-cart-drawer')) customElements.define('hv-cart-drawer', HvCartDrawer);

  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-hv-line-qty]');
    if (!q || q.closest('hv-cart-drawer')) return;
    const line = q.closest('[data-key]');
    const wrap = q.closest('[data-hv-cart-section]');
    if (!line) return;
    if (wrap) wrap.classList.add('hv-is-busy');
    try {
      await HV.cart.change(line.dataset.key, Math.max(0, Number(q.dataset.hvLineQty)));
    } catch (err) {
      HV.toast(err.message);
    }
    if (wrap) wrap.classList.remove('hv-is-busy');
  });

  HV.hydrators = HV.hydrators || [];
  const player = { el: null, btn: null, row: null, limit: 30, raf: null };

  const setPlaying = (btn, on) => {
    const row = btn.closest('[data-hv-track]');
    if (row) row.classList.toggle('is-playing', on);
    btn.setAttribute('aria-label', on ? btn.dataset.labelPause : btn.dataset.labelPlay);
    btn.setAttribute('aria-pressed', String(on));
  };

  const tick = () => {
    if (!player.el) return;
    const t = player.el.currentTime;
    const bar = player.row && player.row.querySelector('[data-hv-progress]');
    if (bar) bar.style.transform = `scaleX(${Math.min(1, t / player.limit)})`;
    if (t >= player.limit) {
      HV.stopAudio();
      return;
    }
    player.raf = requestAnimationFrame(tick);
  };

  HV.stopAudio = () => {
    if (player.el) {
      player.el.pause();
      player.el.src = '';
    }
    if (player.btn) setPlaying(player.btn, false);
    if (player.row) {
      const bar = player.row.querySelector('[data-hv-progress]');
      if (bar) bar.style.transform = 'scaleX(0)';
    }
    cancelAnimationFrame(player.raf);
    player.el = null;
    player.btn = null;
    player.row = null;
  };

  HV.playAudio = (btn) => {
    if (player.btn === btn) {
      HV.stopAudio();
      return;
    }
    HV.stopAudio();
    const el = new Audio(btn.dataset.hvAudio);
    el.preload = 'auto';
    player.el = el;
    player.btn = btn;
    player.row = btn.closest('[data-hv-track]');
    player.limit = Number(btn.dataset.preview || 30);
    el.addEventListener('ended', HV.stopAudio);
    el.addEventListener('error', () => {
      HV.stopAudio();
      HV.toast(S.audioError || 'This preview could not be played.');
    });
    setPlaying(btn, true);
    el.play()
      .then(() => {
        player.raf = requestAnimationFrame(tick);
      })
      .catch(() => HV.stopAudio());
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-hv-audio]');
    if (!btn) return;
    e.preventDefault();
    HV.playAudio(btn);
  });

  HV.hydrators.push((scope) => {
    const vids = scope.querySelectorAll('video[data-hv-lazy]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    if (!HV._vio) {
      HV._vio = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            const v = en.target;
            if (en.isIntersecting) {
              if (HV.reducedMotion()) return;
              if (!v.dataset.loaded) {
                v.preload = 'auto';
                v.dataset.loaded = '1';
              }
              v.play().catch(() => {});
            } else {
              v.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
    }
    vids.forEach((v) => HV._vio.observe(v));
  });

  const initDayNight = () => {
    const body = document.body;
    if (!body || !body.classList.contains('hv-daynight') || body._hvDn) return;
    body._hvDn = true;
    const stops = [
      [0, [247, 245, 240]],
      [0.35, [243, 232, 223]],
      [0.58, [138, 95, 76]],
      [0.78, [43, 33, 28]],
      [1, [17, 15, 13]],
    ];
    const mix = (t) => {
      let i = 0;
      while (i < stops.length - 2 && t > stops[i + 1][0]) i++;
      const a = stops[i];
      const b = stops[i + 1];
      const k = Math.min(1, Math.max(0, (t - a[0]) / (b[0] - a[0])));
      return [0, 1, 2].map((j) => Math.round(a[1][j] + (b[1][j] - a[1][j]) * k));
    };
    const lum = (c) => {
      const f = (v) => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
      };
      return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
    };
    let raf = null;
    let last = -1;
    const update = () => {
      raf = null;
      const d = document.documentElement;
      const max = Math.max(1, d.scrollHeight - window.innerHeight);
      const p = Math.min(1, Math.max(0, window.scrollY / max));
      if (Math.abs(p - last) < 0.002) return;
      last = p;
      const c = mix(p);
      body.style.setProperty('--hv-daynight-bg', `rgb(${c.join(',')})`);
      body.style.setProperty('--hv-p', p.toFixed(3));
      body.classList.toggle('hv-night', lum(c) < 0.18);
    };
    const queue = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', () => {
      last = -1;
      queue();
    });
    update();
  };
  HV.hydrators.push(initDayNight);

  HV.hydrate = (scope) => {
    HV.eta(scope);
    HV.hydrators.forEach((fn) => {
      try {
        fn(scope || document);
      } catch (e) {}
    });
  };

  const boot = () => HV.hydrate(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => HV.hydrate(e.target));
})();
